import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { NexusAccessService } from '../nexusaccess.service';
import { GumOrganizationsService } from '../gumservices/gum-organizations.service';

@Injectable({ providedIn: 'root' })
export class NexusAccessGuard implements CanActivate {
  constructor(
    private access: NexusAccessService,
    private orgService: GumOrganizationsService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const module = route.data['module'];
    const path = route.routeConfig?.path ?? '';

    // --- Vérification classique des droits Nexus ---
    if (module && !this.access.canAccess(module)) {
      return this.deny();
    }

    const isClient = this.orgService.isCurrentOrganizationClient();
    const isPartner = this.orgService.isCurrentOrganizationPartner();

    // --- RÈGLES CLIENT ---
    if (isClient) {
      // Un client ne peut jamais accéder aux partenaires
      if (path.includes('organizations') || path.includes('organization')) {
        return this.deny();
      }
      // Un client ne peut jamais accéder aux clients
      if (path.includes('clients')) {
        return this.deny();
      }
    }

    // --- RÈGLE PARTENAIRE ---
    // Un partenaire peut voir les organisations mais NE PEUT PAS créer un partenaire
    if (isPartner && path === 'management/organization') {
      return this.deny();
    }

    return true;
  }

  private deny(): boolean {
    this.router.navigate(['/dashboard']);
    return false;
  }
}
